<template>
    <keep-alive>
        <component :is="loadPages" :data="currentComponent"></component>
    </keep-alive>
</template>


<script>
    // import "@/assets/css/root.css";
    // import "@/assets/css/style.css";

    import { computed, defineAsyncComponent, onBeforeMount } from "vue";

    import { useStore } from "@/store";
    import { useRoute } from "vue-router";

    import { G, ajax } from "@/_common";

    export default {
        name: 'EmptyL',
        components: {
        },
        props: {
            data: {
                type: Object,
                default: () => {}
            },
        },
        setup(props) {
            const store = useStore();
            const route = useRoute();

            const def_lang = route.params && route.params.lang !== undefined ? route.params.lang : "az";
            store.setLang(def_lang);

            const gpage = G.current;

            gpage.page = props.data
                ? props.data.page || G.defaultPage
                : G.defaultPage;
            gpage.data[gpage.page] = props.data ? props.data.data || "" : "";

            // onMounted(async () => {
                // await ajax({ token: G.getClientData("AUTH_TOKEN") })
                //     .get(store.getAccessRoles())
                //     .then((e) => {
                //         if (e && e.data)
                //             G.access_roles.value = e.data.roles.split(",");
                //     });
            // });

            onBeforeMount(async () => {
                await ajax({
                    url: store.getTranslations(),
                    success: (e) => {
                        // if (e && e.data) store.commit("setTranslations", e.data);
                        store.setTranslations(e.data);
                        // TR.value = store.getTranslation();
                        G.lang = store.getTranslation();
                    },
                    // error: () => {
                    //     // G.atoast.error('Server Connection Error !');
                    //     return null;
                    // }
                });
            });

            // const setComponent = (val) => {
            //     gpage.page = val;
            //     gpage.data[gpage.page] = {};

            //     router.push({ name: val });
            // };

            const currentComponent = computed(() => {
                return gpage.data[gpage.page] || {};
            });

            const loadPages = computed(() => {
                return defineAsyncComponent({
                    loader: () => import(`@/${gpage.page}`),
                    errorComponent: defineAsyncComponent(() =>
                        import("@/pages/NotFound")
                    ),
                    // timeout: 3000,
                    // suspensible: false,
                });
            });

            return { currentComponent, loadPages };
        },
    };
</script>


<style lang="scss">
    #nprogress .bar {
        height: 4px;
    }
    #nprogress .spinner {
        right: auto;
        top: 50%;
        left: 50%;
    }
    .main-content {
        width: calc(100% - 280px);
    }
    @media (max-width: 576px) {
        .main-content {
            width: 100%;
        }
    }
</style>
